import { parseSync } from "oxc-parser";
function useDOMPlugin() {
  return {
    name: "one-vite-dom-plugin",
    async transform(code, id, options) {
      if (!code.includes("use dom")) {
        return;
      }
      try {
        var parsed = parseSync(id, code);
        var hasUseDom = false;
        for (var i = 0; i < parsed.program.body.length; ++i) {
          var item = parsed.program.body[i];
          if (item.type === "ExpressionStatement") {
            var _item_expression, _item_expression1, _item_expression2, _item_expression3;
            if (item.directive === "use dom" || ((_item_expression = item.expression) === null || _item_expression === void 0 ? void 0 : _item_expression.type) === "Literal" && ((_item_expression1 = item.expression) === null || _item_expression1 === void 0 ? void 0 : _item_expression1.value) === "use dom" || ((_item_expression2 = item.expression) === null || _item_expression2 === void 0 ? void 0 : _item_expression2.type) === "StringLiteral" && ((_item_expression3 = item.expression) === null || _item_expression3 === void 0 ? void 0 : _item_expression3.value) === "use dom") {
              hasUseDom = true;
              break;
            }
          }
        }
        if (!hasUseDom) {
          return;
        }
      } catch (unused) {
        return;
      }
    }
  };
}
export {
  useDOMPlugin
};
//# sourceMappingURL=useDomPlugin.js.map
